import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function justificativaalteracaoencerrantes(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@justificativaalteracaoencerrantes/FIND_JUSTIFICATIVAALTERACAOENCERRANTE':
      case '@justificativaalteracaoencerrantes/UPDATE_JUSTIFICATIVAALTERACAOENCERRANTE':
      case '@justificativaalteracaoencerrantes/DELETE_JUSTIFICATIVAALTERACAOENCERRANTE':
      case '@justificativaalteracaoencerrantes/STORE_JUSTIFICATIVAALTERACAOENCERRANTE':
      case '@justificativaalteracaoencerrantes/JUSTIFICATIVAALTERACAOENCERRANTES_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@justificativaalteracaoencerrantes/SUCCESS_REMOVE':
      case '@justificativaalteracaoencerrantes/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@justificativaalteracaoencerrantes/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.justificativaalteracaoencerrantes;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@justificativaalteracaoencerrantes/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.justificativaalteracaoencerrante;
        break;
      }

      case '@justificativaalteracaoencerrantes/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
